exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard_frame_32eI3 {\n    display: block;\n    width: 100%;\n    height: 100%;\n    min-width: 0;\n    border: 0;\n}\n", ""]);

// exports
exports.locals = {
	"frame": "dashboard_frame_32eI3"
};